/**
 * jQuery-free source tracking library.
 *
 * Usage:
 * var sourceTracker = window.TrimarkCreateSourceTracker({
 *   strategy: 'ft',
 *   cookie: {
 *     name: { ft: 'trmk_src_first', lt: 'trmk_src_last' },
 *     opts: { expires: 1, path: '/' },
 *   },
 *   forms: { prefillAttr: 'data-prefill' },
 * });
 * sourceTracker.init();
 * sourceTracker.populateFormFields();
 *
 * @param {object} settings
 * @returns {object} SourceTracker module
 */
window.TrimarkCreateSourceTracker = function (settings) {
	var module = {
		settings: settings,
		hasInit: false,
		init: function () {
			if (this.hasInit) {
				console.warn('SourceTracker has already been initialized.');
				return;
			}

			if (typeof Cookies === 'undefined') {
				console.warn('Please install js-cookie library to enable the SourceTracker library.');
				return;
			}

			this.hasInit = true;
			this.setSourceCookies();
			window.TrimarkSourceTracker = this;
			document.dispatchEvent(new CustomEvent('trmk:source-tracker-initialized'));
		},
		getSourceData: function () {
			var cookieName = this.settings.cookie.name[this.settings.strategy];
			return Cookies.get(cookieName) ? JSON.parse(Cookies.get(cookieName)) : {};
		},
		setSourceCookies: function () {
			var params = new URLSearchParams(window.location.search);
			var cookie = {};

			params.forEach(function (val, key) {
				cookie[key] = val;
			});

			cookie.referrer = document.referrer;
			cookie.landing_pg = window.location.href;

			// A page with no src/lp param (e.g. an organic pageview visited before
			// the tracked landing page) shouldn't be able to permanently claim
			// first-touch attribution ahead of a later page that actually carries one.
			var hasTrackingParams = params.has('src') || params.has('lp');
			var ftCookieName = this.settings.cookie.name.ft;
			var existingFt = Cookies.get(ftCookieName);
			var ftIsUntracked = true;

			if (typeof existingFt !== 'undefined') {
				try {
					var existingFtData = JSON.parse(existingFt);
					ftIsUntracked = !existingFtData.src && !existingFtData.lp;
				} catch (e) {
					ftIsUntracked = true;
				}
			}

			if (typeof existingFt === 'undefined' || (ftIsUntracked && hasTrackingParams)) {
				Cookies.set(ftCookieName, JSON.stringify(cookie), this.settings.cookie.opts);
			}

			Cookies.set(this.settings.cookie.name.lt, JSON.stringify(cookie), this.settings.cookie.opts);
		},
		populateFormFields: function () {
			if (!this.hasInit) {
				console.warn('SourceTracker has not been initialized. Please call init() before populating form fields.');
				return;
			}

			var cookieName = this.settings.cookie.name[this.settings.strategy];
			var vars = Cookies.get(cookieName) ? JSON.parse(Cookies.get(cookieName)) : {};
			var attr = this.settings.forms.prefillAttr;

			Object.keys(vars).forEach(function (key) {
				var fields = document.querySelectorAll('[' + attr + '="' + key + '"]');
				Array.prototype.forEach.call(fields, function (el) {
					el.value = vars[key];
				});
			});
		},
	};

	return module;
};
